const buildTimeStrapiUrl = import.meta.env.VITE_STRAPI_URL;
const buildTimeEnv = import.meta.env.VITE_ENVIRONMENT;

const URL_TO_STRAPI = [
  ['localhost', buildTimeStrapiUrl || 'http://localhost:8443'],
  ['fns.dev', 'https://strapi.dev.science.org.au'],
  ['fns.test', 'https://strapi.test.science.org.au'],
  ['fns.staging', 'https://strapi.staging.science.org.au'],
];

const URL_TO_ENV = [
  ['localhost', 'development'],
  ['fns.dev', 'development'],
  ['fns.test', 'test'],
  ['fns.staging', 'staging'],
];

const fromHref = (mapping, fallback) => {
  const href = typeof window !== 'undefined' ? window.location.href : '';
  const hit = mapping.find(([needle]) => href.includes(needle));
  if (!hit) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn(
        `[env] runtime URL inspection fell through to production fallback (href=${href}). Set VITE_ENVIRONMENT + VITE_STRAPI_URL at build time to avoid this.`,
      );
    }
    return fallback;
  }
  return hit[1];
};

export const strapiUrl =
  buildTimeStrapiUrl ||
  fromHref(URL_TO_STRAPI, 'https://strapi.science.org.au');
export const strapiApiUrl = `${strapiUrl}/api/`;
export const environment = buildTimeEnv || fromHref(URL_TO_ENV, 'production');
export const isProduction = environment === 'production';

// Default pagination limit for collection fetches that need the full set
export const DEFAULT_PAGINATION_LIMIT = 10000;

// Max size of uploaded files (bytes)
export const FILE_UPLOAD_MAX_BYTES = 3000000;

// Timing constants (milliseconds)
export const NOTIFICATION_DISPLAY_MS = 10000;
export const POST_SUBMIT_REDIRECT_MS = 2000;
export const MENU_TOGGLE_DELAY_MS = 15000;

export const cmSeLabel =
  'CMSE: Corresponding Membership and Special Election Committee';

export const STATUS_STYLES = {
  1: { label: 'Draft', variant: 'shortlisted' },
  2: { label: 'Submitted', variant: 'shortlisted' },
  3: { label: 'Shortlisted', variant: 'shortlisted' },
  4: { label: 'Elected', variant: 'shortlisted' },
  5: { label: 'Expired', variant: 'shortlisted' },
  6: { label: 'Suspended', variant: 'shortlisted' },
  7: { label: 'Withdrawn', variant: 'shortlisted' },
  8: { label: 'Recommended', variant: 'shortlisted' },
};

// Nomination Status Types (nomination_status_types table)
export const NOMINATION_STATUS = {
  DRAFT: 1,
  SUBMITTED: 2,
  SHORTLISTED: 3,
  ELECTED: 4,
  EXPIRED: 5,
  SUSPENDED: 6,
  WITHDRAWN: 7,
  RECOMMENDED: 8,
};

// Referee Status Types (referee_statuses table)
export const REFEREE_STATUS = {
  PENDING: 1,
  SUBMITTED: 2,
  DECLINED: 3,
  USE_EXISTING: 4,
  EXTENSION_REQUESTED: 5,
  EXTENSION_APPROVED: 6,
};

// Election Types (election_types table)
export const ELECTION_TYPE = {
  CORRESPONDING_MEMBER: 1,
  ORDINARY: 2,
  SPECIAL_ELECTION: 3,
};

// Committee IDs (sectional_committees table)
export const CM_PRIMARY_ID = 14;
export const SE_COMMITTEE_ID = 15;
export const CMSE_COMMITTEE_IDS = [CM_PRIMARY_ID, SE_COMMITTEE_ID];

// Decline Reasons (decline_reasons table)
export const DECLINE_REASON = {
  OTHER: 5,
};

// Default Strapi role for new users
export const DEFAULT_USER_ROLE_ID = 1;
